module.exports = __webpack_public_path__ + "media/images/bg-pattern-dark-eec10bdf6498f577cd05cfadb06f8bdf.png";